import { tns } from 'tiny-slider/src/tiny-slider';
import BaseComponent from 'foundation/base-component';

const ERROR_MARGIN = 2;
class MultimediaCarouselComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.gallery = null;
        this.sliderInfo = null;
        this.lastSlide = null;
        this.currentSlidePosition = null;
        this.slidesContainerPosition = null;

        this.init();
    }

    static getRequiredRefs() {
        return ['slides'];
    }

    init() {
        this.gallery = tns({
            container: this.refs.slides,
            autoWidth: true,
            loop: false,
            nav: false,
            controls: false,
            touch: false,
            responsive: {
                579: {
                    slideBy: 2
                },
                1023: {
                    slideBy: 3
                }
            }
        });

        if (Array.isArray(this.refs.prevBtn)) {
            this.refs.prevBtn.forEach((x) => {
                this.addListener(x, 'click', this.onClickPrevBtn);
            });
        }
        if (Array.isArray(this.refs.nextBtn)) {
            this.refs.nextBtn.forEach((x) => {
                this.addListener(x, 'click', this.onClickNextBtn);
            });
        }
    }

    onClickPrevBtn = (event) => {
        event.preventDefault();
        this.gallery.goTo('prev');
    }

    onClickNextBtn = (event) => {
        event.preventDefault();
        this.gallery.goTo('next');
        this.sliderInfo = this.gallery.getInfo();
        if ( this.isSliderEnd() )
        {
            this.handleLastSlide();   
        }
    }

    onDestroy() {
        this.gallery.destroy();
    }
    isSliderEnd()
    {
        return this.sliderInfo.index > this.sliderInfo.slideCount - 2 * this.sliderInfo.slideBy;
    }

    handleLastSlide()
    {
        this.lastSlide = this.sliderInfo.slideItems[ this.sliderInfo.slideCount - 1 ];
        const { x, y, z } = this.getTranslateValues( this.refs.slides );
        this.currentSlidePosition = this.sliderInfo.slideItems[ this.sliderInfo.index ].getBoundingClientRect();
        this.slidesContainerPosition = this.refs.slides.parentElement.getBoundingClientRect();
        if ( this.notCurrentSlideDisplayedOk() )
        {
            this.setCurrentSlidePosition( x, y, z );
        }
        else
        {
            if ( !this.isFullyShown( this.lastSlide, this.refs.slides.parentElement ) )
            {
                this.setLastSlidePosition( x, y, z );
            }
        }
    }

    getTranslateValues( element )
    {
        const style = window.getComputedStyle(element)
        const matrix = style['transform'] || style.webkitTransform || style.mozTransform

        if (matrix === 'none') {
            return {
            x: 0,
            y: 0,
            z: 0
            }
        }
        const matrixType = matrix.includes('3d') ? '3d' : '2d'
        const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')

        // 2d matrices have 6 values
        // Last 2 values are X and Y.
        if (matrixType === '2d') {
            return {
            x: matrixValues[4],
            y: matrixValues[5],
            z: 0
            }
        }

        // 3d matrices have 16 values
        // The 13th, 14th, and 15th values are X, Y, and Z
        if (matrixType === '3d') {
            return {
            x: matrixValues[12],
            y: matrixValues[13],
            z: matrixValues[14]
            }
        }
    }

    notCurrentSlideDisplayedOk()
    {
        return (
            this.sliderInfo.index < this.sliderInfo.slideCount - this.sliderInfo.slideBy &&
            this.currentSlidePosition.left > this.slidesContainerPosition.left + ERROR_MARGIN
        );
    }

    setCurrentSlidePosition(currentX, currentY, currentZ)
    {
        this.setNewTranslate( currentX - (this.currentSlidePosition.left - this.slidesContainerPosition.left), currentY, currentZ, this.refs.slides );
    }
    setLastSlidePosition(currentX, currentY, currentZ)
    {
        var lastSlidePosition = this.lastSlide.getBoundingClientRect();
        this.setNewTranslate( currentX - (lastSlidePosition.right - this.slidesContainerPosition.right), currentY, currentZ, this.refs.slides );
    }
    setNewTranslate( newX, newY, newZ, element )
    {
        element.style.transform = `translate3d(${newX}px, ${newY}px, ${newZ}px)`;
    }

    isFullyShown(element, container) {
        const elementPosition = element.getBoundingClientRect();
        const containerPosition = container.getBoundingClientRect();
        return (
            elementPosition.right <= containerPosition.right &&
            elementPosition.left  >= containerPosition.left
        );
    }


}

export default MultimediaCarouselComponent;
